var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 4.2504L4.62403 7.8175C4.16068 8.2545 3.53225 8.5 2.87697 8.5C2.22169 8.5 1.59326 8.2545 1.12991 7.8175C0.666557 7.3805 0.40625 6.78781 0.40625 6.1698C0.40625 5.5518 0.666557 4.9591 1.12991 4.5221L4.91212 0.954999C5.22102 0.663668 5.63998 0.5 6.07683 0.5C6.51368 0.5 6.93264 0.663668 7.24154 0.954999C7.55044 1.24633 7.72398 1.64146 7.72398 2.05347C7.72398 2.46547 7.55044 2.8606 7.24154 3.15193L3.45521 6.71904C3.30076 6.8647 3.09128 6.94654 2.87285 6.94654C2.65443 6.94654 2.44495 6.8647 2.2905 6.71904C2.13605 6.57337 2.04928 6.3758 2.04928 6.1698C2.04928 5.9638 2.13605 5.76623 2.2905 5.62057L5.78463 2.32905",
    stroke: "#565556",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.af51f33d8b927e584b9115d45aacd409.svg";
export { ForwardRef as ReactComponent };